// The five calculator slugs spec 001 (nwjs-structured-content-editor) lets an
// author pick, mapped to the human label the placeholder renders. `Record<
// string, string>` (not a union) so an unknown slug is a lookup miss handled
// at render time, not a type error.
export const CALCULATOR_LABELS: Record<string, string> = {
  'cd-calculator': 'CD Calculator',
  'compound-interest-calculator': 'Compound Interest Calculator',
  'interest-calculator': 'Interest Calculator',
  'savings-apy-boost-calculator': 'Savings APY Boost Calculator',
  'savings-calculator': 'Savings Calculator',
};
